const PROMO = {
  enabled: true,
  image: "/promo/desayuno.png",
  alt: "Desayuno CROC LAB: bocadillo y zumo por 5,90 €, de lunes a viernes de 9 a 11. Crujiente por fuera. Brutal por dentro.",
};

const PromoBanner = () => {
  if (!PROMO.enabled) return null;
  return (
    <section data-testid="promo-banner" aria-label="Promoción actual">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-6 md:pt-10">
        <img
          src={PROMO.image}
          alt={PROMO.alt}
          data-testid="promo-banner-image"
          className="w-full h-auto rounded-3xl shadow-xl"
        />
      </div>
    </section>
  );
};

export default PromoBanner;
